import { createSlice } from "@reduxjs/toolkit";
import CustomAxios from "../utilities/service/api.service";
import CheckAuthorization from "../utilities/auth/checkAuthorization";
import { API } from "../utilities/constants";

const initialState = {
  app_role_epos: "",
  loadingEpos: 0,
  eposdropdownLoading: 0,
  epostableLoading: 0,
  loadingExportDataEpos: 0,
  data_filters_epos: {},
  filters_epos: {
    customer_type: [],
    customer_retail: [],
    customer_channel: [],
    customer_market: [],
    year: [],
    period: [],
    week: [],
    kpis: [],
    product_animal_type: [],
    product_segment: [],
    product_manufacturer: [],
    product_brand: [],
    periodicity: [],
  },
  kpis_in_api_epos: {},
  customer_type: [],
  customer_retail: [],
  customer_channel: [],
  customer_market: [],
  year: [],
  period: [],
  week: [],
  kpis: [],
  time_frames_epos: [],
  product_animal_type: [],
  product_segment: [],
  product_manufacturer: [],
  product_brand: [],
  periodicity: [],
  epos_kpis_api: [],
  epos_filters_kpis: [],
  eposYear: [],
  eposYearPeriod: [],
  eposYearPeriodWeek: [],
  epostimeframeCheckbox: [],
  timeHorizonRadioEpos: "rolledup",
  timeSelection_calendar: {},
  timeSelection_dynamic_weekly: [],
  eposcolumnSelectionCheckbox: [
    "customer_id__market",
    "customer_id__channel",
    "customer_id__retailer",
    "product_id__animal_type",
    "product_id__segment",
    "product_id__manufacturer",
    "product_id__brand",
  ],
  dataset_selected_epos: "epos",
  eposincludeAllCheckbox: [""],
  includeAllLevelsonLoad: [
    "customer_id__market",
    "customer_id__channel",
    "customer_id__retailer",
    "product_id__animal_type",
    "product_id__segment",
    "product_id__manufacturer",
    "product_id__brand",
  ],
  epostabledataPreview: [],
  epostabledataPreviewColumns: [],
  epos_export_Data: [],
  epos_email_address: "",
  previewFormatEpos: false,
  epos_dataset_selected: "epos",
  epos_bookmark_data: [],
};

const eposfiltersSlicer = createSlice({
  name: "eposfilters",
  initialState,
  reducers: {
    setAppRoleEposPage: (state, action) => ({
      ...state,
      app_role_epos: action.payload,
    }),
    setLoadingEpos: (state, action) => ({
      ...state,
      loadingEpos: state.loading + (action.payload ? 1 : -1),
    }),
    setEposDropdownLoading: (state, action) => ({
      ...state,
      eposdropdownLoading:
        state.eposdropdownLoading + (action.payload ? 1 : -1),
    }),
    setEposTableLoading: (state, action) => ({
      ...state,
      epostableLoading: state.epostableLoading + (action.payload ? 1 : -1),
    }),
    setEposExportDataLoading: (state, action) => ({
      ...state,
      loadingExportDataEpos:
        state.loadingExportDataEpos + (action.payload ? 1 : -1),
    }),
    setEposFilters: (state, action) => ({
      ...state,
      filters_epos: action.payload,
    }),
    setEposDataFilters: (state, action) => ({
      ...state,
      data_filters_epos: action.payload,
    }),
    setEposKPIs: (state, action) => ({
      ...state,
      kpis_in_api_epos: action.payload,
    }),
    setEPOSapiKPIs: (state, action) => ({
      ...state,
      epos_kpis_api: action.payload,
    }),
    setEPOSfiltersKpis: (state, action) => ({
      ...state,
      epos_filters_kpis: action.payload,
    }),
    setEposYear: (state, action) => ({
      ...state,
      eposYear: action.payload,
    }),
    setEposYearPeriod: (state, action) => ({
      ...state,
      eposYearPeriod: action.payload,
    }),
    setEposYearPeriodWeek: (state, action) => ({
      ...state,
      eposYearPeriodWeek: action.payload,
    }),
    setTimeSelectionData: (state, action) => ({
      ...state,
      timeSelection_calendar: action.payload,
    }),
    setTimeSelectedfromDynamicWeekly: (state, action) => ({
      ...state,
      timeSelection_dynamic_weekly: action.payload,
    }),
    setEposDataDropdown: (state, action) => ({
      ...state,
      [action.payload[0]]: action.payload[1],
    }),
    setEposTableDataPreview: (state, action) => ({
      ...state,
      epostabledataPreview: action.payload,
    }),
    setEposTableDataPreviewColumns: (state, action) => ({
      ...state,
      epostabledataPreviewColumns: action.payload,
    }),
    seteposTimeframeCheckbox: (state, action) => ({
      ...state,
      epostimeframeCheckbox: action.payload,
    }),
    setEposTimeHorizonRadio: (state, action) => ({
      ...state,
      timeHorizonRadioEpos: action.payload,
    }),
    seteposcolumnSelectionCheckbox: (state, action) => ({
      ...state,
      eposcolumnSelectionCheckbox: action.payload,
    }),
    setDatasetEpos: (state, action) => ({
      ...state,
      dataset_selected_epos: action.payload,
    }),
    setincludeAllCheckboxEpos: (state, action) => ({
      ...state,
      eposincludeAllCheckbox: action.payload,
    }),
    setEposExportData: (state, action) => ({
      ...state,
      epos_export_Data: action.payload,
    }),
    setEmailAddressEpos: (state, action) => ({
      ...state,
      epos_email_address: action.payload,
    }),
    setPreviewFormatEpos: (state, action) => ({
      ...state,
      previewFormatEpos: action.payload,
    }),
    setEposBookmarkData: (state, action) => ({
      ...state,
      epos_bookmark_data: action.payload,
    }),
  },
});

export const {
  setAppRoleEposPage,
  setLoadingEpos,
  setEposDropdownLoading,
  setEposTableLoading,
  setEposExportDataLoading,
  setEposFilters,
  setEposDataFilters,
  setEposKPIs,
  setEPOSapiKPIs,
  setEPOSfiltersKpis,
  setEposYear,
  setEposYearPeriod,
  setEposYearPeriodWeek,
  setTimeSelectionData,
  setTimeSelectedfromDynamicWeekly,
  setEposDataDropdown,
  setEposTableDataPreview,
  setEposTableDataPreviewColumns,
  seteposTimeframeCheckbox,
  setEposTimeHorizonRadio,
  seteposcolumnSelectionCheckbox,
  setDatasetEpos,
  setincludeAllCheckboxEpos,
  setEposExportData,
  setEmailAddressEpos,
  setPreviewFormatEpos,
  setEposBookmarkData,
} = eposfiltersSlicer.actions;

//function for obtaining data in epos filters dropdowns
export const getEposFilters = (filters_epos) => async (dispatch, getState) => {
  let urlFilters = { ...filters_epos };
  Object.keys(urlFilters).forEach((key) => {
    if (urlFilters[key].length === 0) {
      delete urlFilters[key];
    }
  });
  dispatch(setEposDropdownLoading(true));
  CustomAxios(API.epos_dropdowns, "POST", urlFilters)
    .then((response) => {
      if (response.data.error_code === undefined) {
        let data_filters = response.data;
        dispatch(setEposDataFilters(data_filters));
        data_filters.product_animal_type &&
          data_filters.product_animal_type.length &&
          dispatch(
            setEposDataDropdown([
              "product_animal_type",
              data_filters.product_animal_type,
            ])
          );
        data_filters.product_segment &&
          data_filters.product_segment.length &&
          dispatch(
            setEposDataDropdown([
              "product_segment",
              data_filters.product_segment,
            ])
          );
        data_filters.product_manufacturer &&
          data_filters.product_manufacturer.length &&
          dispatch(
            setEposDataDropdown([
              "product_manufacturer",
              data_filters.product_manufacturer,
            ])
          );
        data_filters.product_brand &&
          data_filters.product_brand.length &&
          dispatch(
            setEposDataDropdown(["product_brand", data_filters.product_brand])
          );
        data_filters.customer_channel &&
          data_filters.customer_channel.length &&
          dispatch(
            setEposDataDropdown([
              "customer_channel",
              data_filters.customer_channel,
            ])
          );
        data_filters.customer_market &&
          data_filters.customer_market.length &&
          dispatch(
            setEposDataDropdown([
              "customer_market",
              data_filters.customer_market,
            ])
          );
        data_filters.customer_retail &&
          data_filters.customer_retail.length &&
          dispatch(
            setEposDataDropdown([
              "customer_retail",
              data_filters.customer_retail,
            ])
          );
        data_filters.customer_type &&
          data_filters.customer_type.length &&
          dispatch(
            setEposDataDropdown(["customer_type", data_filters.customer_type])
          );
        data_filters.period &&
          data_filters.period.length &&
          dispatch(setEposDataDropdown(["period", data_filters.period]));
        data_filters.week &&
          data_filters.week.length &&
          dispatch(setEposDataDropdown(["week", data_filters.week]));
        data_filters.year &&
          data_filters.year.length &&
          dispatch(setEposDataDropdown(["year", data_filters.year]));
        data_filters.kpis &&
          data_filters.kpis.length &&
          dispatch(setEposDataDropdown(["kpis", data_filters.kpis]));
        data_filters.periodicity &&
          data_filters.periodicity.length &&
          dispatch(
            setEposDataDropdown(["periodicity", data_filters.periodicity])
          );
      }
      dispatch(setEposDropdownLoading(false));
    })
    .catch((err) => {
      console.error("Epos Data Filters Dropdown API Failed", err);
      if (err.status === 403) {
        CheckAuthorization();
      }
      dispatch(setEposDropdownLoading(false));
    });
};

//function for obtaining kpis dropdown data, calendar data in dynamic weekly scenario
export const getEposKPIs = (kpis_in_api_epos) => async (dispatch, getState) => {
  dispatch(setEposDropdownLoading(true));

  CustomAxios(API.epos_kpis, "GET", kpis_in_api_epos)
    .then((response) => {
      if (response.data.error_code === undefined) {
        let epos_kpis = response.data;
        dispatch(setEposKPIs(epos_kpis));
        epos_kpis.calendar &&
          dispatch(setTimeSelectionData(epos_kpis.calendar));
        epos_kpis.kpis && dispatch(setEPOSapiKPIs(epos_kpis.kpis));
      }
      dispatch(setEposDropdownLoading(false));
    })
    .catch((err) => {
      console.error("Epos KPIs API Failed", err);
      if (err.status === 403) {
        CheckAuthorization();
      }
      dispatch(setEposDropdownLoading(false));
    });
};

export default eposfiltersSlicer.reducer;
